import { useRef } from 'react';
import { useActiveClassroom } from '../../context/ActiveClassroomProvider.js';
import { useFitScale } from '../../hooks/useFitScale.js';
import feelingsImg from '../../../../../assets/feelings/Feelings.png';
import styles from './Feelings.module.css';

/**
 * Feelings live page — single composite poster showing all 25
 * feelings in 5 color-banded rows. Wrapped in the same card chrome
 * as the other live pages (Number, Weather) so it reads as a peer
 * teaching surface. Static display, no per-feeling tap state.
 */
export function Feelings() {
  const { active } = useActiveClassroom();

  // Scale the poster card down to fit the live safe box on shorter/Retina
  // displays (never upscales past the artwork's natural size).
  const pageRef = useRef<HTMLElement>(null);
  const cardRef = useRef<HTMLDivElement>(null);
  const fitScale = useFitScale(pageRef, cardRef);

  if (!active) {
    return (
      <section className={styles.empty} role="status">
        No classroom selected.
      </section>
    );
  }

  return (
    <section className={styles.feelings} data-testid="feelings-page" ref={pageRef}>
      <div className={styles.card} ref={cardRef} style={{ transform: `scale(${fitScale})` }}>
        <h1 className={styles.title}>How are you feeling today?</h1>
        <img
          src={feelingsImg}
          alt="A poster of 25 feelings, grouped by color: green for calm, yellow for happy, blue for sad, pink for anxious, red for mad."
          className={styles.poster}
          data-testid="feelings-poster"
        />
      </div>
    </section>
  );
}
